import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'sonner'
import { ConfirmProvider } from '@orisini/ui/components/confirm'
import App from './App'
import './index.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      {/* Konvensi: notifikasi lewat sonner, dialog lewat useConfirm/usePrompt.
          Dilarang alert()/confirm()/prompt(). */}
      <ConfirmProvider>
        <App />
      </ConfirmProvider>
      <Toaster richColors position="top-right" />
    </BrowserRouter>
  </StrictMode>,
)
